import { render } from "./TheMenuInstanzenSelectItem.pug?vue&type=template&id=60192f9f&lang=pug"
import script from "./TheMenuInstanzenSelectItem.js?vue&type=script&lang=js"
export * from "./TheMenuInstanzenSelectItem.js?vue&type=script&lang=js"

import exportComponent from "/builds/projekte/pvp/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__